export default __webpack_public_path__ + "static/media/google-register-1-tw.3514cae9.jpeg";